module.exports = __webpack_public_path__ + "img/1492771359.e342803e.jpg";